import { LoadDataFunctionType, LoadDataType } from 'dd-server/site/types';
import { metricsModule } from 'dd-client/site/common/utils/metrics/metrics';
import { QUERY } from 'dd-client/site/common/utils/query/query';
import { PastDealsType } from 'dd-client/site/pastDeals/hooks/usePastDeals';

const APP_MODULE = 'past_deals_page';

const loadData: LoadDataFunctionType = (match, language): LoadDataType => {
  metricsModule.run(({ metrics }) => {
    metrics.increment(`${APP_MODULE}.request`);
  });

  const queries = [
    {
      isInfiniteQuery: true,
      isMainQuery: true,
      queryFunction: QUERY.pastDeals.queryFunction,
      queryKey: [QUERY.pastDeals.queryName, language, PastDealsType.ALL, null, null],
    },
  ];

  return {
    appModule: APP_MODULE,
    queries,
  };
};

export {
  loadData,
};
